
import { Component, Mixins, Prop } from "vue-property-decorator"
import uniqueIdMixin from "@/mixins/uniqueIdMixin"

/**
 * The help icon displays an icon with a popover containing the text specified in the default slot
 * You can optionally display a using the help-title prop
 */
@Component({})
export default class HelpIcon extends Mixins(uniqueIdMixin) {
	@Prop({ type: String, default: "" }) helpTitle!: string

	private get iconId () {
		return `help-icon-${this.uniqueId}`
	}
}
